import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    selector: {
        width: '17%'
    },
    selectorsContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        padding: '15px',
        width: '100%'
    }
}));
